import { Section } from '@all-hands-hq/plex-graphql-schema';

export function getSelectedContent({
  document,
  selectedSections,
}: {
  document: Section;
  selectedSections: Section[];
}): { titleSection: Section; selectedIndexes: boolean[] } {
  // Compute indexes from the original document which fall under either a selected section or are a title of
  // a section which is partially selected
  const selectedIndexes = new Array<boolean>(document.endIndex).fill(false);

  // Mark content of selected sections to import
  selectedSections.forEach((section) => {
    selectedIndexes.fill(true, section.startIndex + 1, section.endIndex);
  });

  // Mark content of parent section titles between selected sections and their lowest common ancestor
  const lowestCommonAncestor =
    selectedSections.length > 0
      ? selectedSections.reduce(
          (accumulator: Section, current: Section) => Section.getLowestCommonAncestor(accumulator, current),
          selectedSections[0]
        )
      : document;

  selectedSections.forEach((section) => {
    let iterator: Section | null = section;
    while (iterator != null && iterator !== lowestCommonAncestor) {
      // Mark just the title to import
      selectedIndexes[iterator.startIndex] = true;
      iterator = iterator.parent;
    }
  });

  return {
    titleSection: lowestCommonAncestor,
    selectedIndexes,
  };
}
